class PriceToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.toggleButton = this.querySelector('[data-price-toggle]');
    this.priceContainer = this.querySelector('[data-product-price]');
    this.toggleText = this.toggleButton?.querySelector('.price-toggle-text');
    
    if (!this.toggleButton || !this.priceContainer) return;
    
    // Get saved preference from localStorage (default: show prices)
    this.isPriceVisible = localStorage.getItem('productPriceVisible') !== 'false';
    
    // Set initial state
    this.updatePriceVisibility();
    
    // Add click event listener
    this.toggleButton.addEventListener('click', () => {
      this.isPriceVisible = !this.isPriceVisible;
      localStorage.setItem('productPriceVisible', this.isPriceVisible);
      this.updatePriceVisibility();
      
      // Update all other price toggles on the page
      document.querySelectorAll('price-toggle').forEach(toggle => {
        if (toggle !== this) {
          toggle.isPriceVisible = this.isPriceVisible;
          toggle.updatePriceVisibility();
        }
      });
    });
  }

  updatePriceVisibility() {
    if (!this.toggleButton || !this.priceContainer || !this.toggleText) return;
    
    if (this.isPriceVisible) {
      this.priceContainer.style.display = '';
      this.toggleText.textContent = 'Hide Price';
      this.toggleButton.classList.add('active');
    } else {
      this.priceContainer.style.display = 'none';
      this.toggleText.textContent = 'Show Price';
      this.toggleButton.classList.remove('active');
    }
  }
}

customElements.define('price-toggle', PriceToggle);
